module.exports = __webpack_public_path__ + "static/img/sspg_07.c8f8d4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sspg/sspg_07.jpg
// module id = CAQf
// module chunks = 1